import styled from 'astroturf/react';

import { Reader as ReaderBase } from 'js/social/Reader/Reader';
import _Reader from "Reader.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/Reader/Reader.ts?styleId=Reader";


// NOTE(emily): I can't find a way to pass a prop named fullWidth to the inner
// <ReaderBase /> component while also using it as a dynamic prop here, so this
// has a funny name to distinguish it from the inner fullWidth prop.
const Reader = /*#__PURE__*/styled(ReaderBase, null, {
  displayName: "Reader",
  styles: _Reader
});

export default Reader;
